module.exports = __webpack_public_path__ + "assets/img/face_contrast_example3.c42239f8.png";